import { removeFoldersFromUrl } from './removeFoldersFromUrl'

const DEFAULT_LANGUAGE = process.env.GATSBY_DEFAULT_LANGUAGE

export const getUrl = (link: Link) => {
  const path = link?.url ? link?.url?.split('/') : link?.cached_url?.split('/')

  if (path?.length > 1 && path[0] === DEFAULT_LANGUAGE) {
    path[0] = ''
    const fullUrl = path.join('/')
    return removeFoldersFromUrl(fullUrl)
  }

  return removeFoldersFromUrl(link?.url || link?.cached_url)
}
